import React, {useEffect, useState} from 'react';
import TextInput from "../../../ui_components/TextInput/TextInput";
import PersonIcon from '@material-ui/icons/Person';
import SellerNameInputProperties from "./SellerNameInputProperties";
import {useI18nContext} from "../../../contexts/I18nContext";

const SellerNameInput: React.FC<SellerNameInputProperties> = ({
                                                                  value,
                                                                  required = false,
                                                                  placeholder,
                                                                  onChange,
                                                                  disabled,
                                                                  fullWidth = false,
                                                                  autoFocus = false,
                                                                  className = '',
                                                                  error
                                                              }) => {

    const [name, setName] = useState(value);
    const i18n = useI18nContext();

    useEffect(() => {
        setName(value);
    }, [value]);

    const onNameChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newName = event.target.value;
        setName(newName);
        onChange(newName);
    }

    return (
        <TextInput
            error={error}
            label={i18n.translate("NAME") + `${required ? '*' : ''}`}
            value={name}
            placeholder={placeholder}
            disabled={disabled}
            onChange={onNameChange}
            startIcon={PersonIcon}
            className={className}
            fullWidth={fullWidth}
            autoFocus={autoFocus}
        />
    )
}


export default SellerNameInput;